const keypress = {
  keys: {
    // these are the values for the "key" event in modern browsers
    space: "Space",
    spacebar: "Spacebar",
    " ": " ",
    enter: "Enter",
    arrowDown: "ArrowDown",
    down: "Down",
    arrowUp: "ArrowUp",
    up: "Up",
    esc: "Esc",
    escape: "Escape",
    tab: "Tab",
    shiftTab: "ShiftTab",
    alt: "Alt",
    shift: "Shift",
    home: "Home",
    end: "End",
    backspace: "Backspace",
    comma: ",",
    delete: "Delete",
    del: "Del",
    arrowLeft: "ArrowLeft",
    left: "Left",
    pgdown: "PageDown",
    pgup: "PageUp",
    period: ".",
    arrowRight: "ArrowRight",
    right: "Right",
  },
  actions: {
    space: key => key === keypress.keys.space || key === keypress.keys.spacebar || key === keypress.keys[" "],
    esc: key => key === keypress.keys.esc || key === keypress.keys.escape,
    left: key => key === keypress.keys.left || key === keypress.keys.arrowLeft,
    right: key => key === keypress.keys.right || key === keypress.keys.arrowRight,
    down: key => key === keypress.keys.down || key === keypress.keys.arrowDown,
    up: key => key === keypress.keys.up || key === keypress.keys.arrowUp,
    enter: key => key === keypress.keys.enter,
    tab: key => key === keypress.keys.tab,
    shiftTab: key => key === keypress.keys.shiftTab,
    home: key => key === keypress.keys.home,
    end: key => key === keypress.keys.end,
    activateControl: key => keypress.actions.space(key) || keypress.actions.enter(key),
  }
}

export {
  keypress
}